import { render, staticRenderFns } from "./turmas.vue?vue&type=template&id=4a5ce83c"
import script from "./turmas.vue?vue&type=script&lang=js"
export * from "./turmas.vue?vue&type=script&lang=js"
import style0 from "./turmas.vue?vue&type=style&index=0&id=4a5ce83c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports